import { memo } from "react";

export const CustomerSmsSubscriberDetails = memo(
  function CustomerSmsSubscriberDetails() {
    return null;
  },
);
